// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const ArrowRightIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 7H17" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 13L17 7L11 1" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ArrowRightIcon;
